<template>
  <div class="animated fadeIn">
    <div v-if="!person._id">
      <p>Person not found, or you do not have access to this person in the given Org/Group context.</p>
    </div>
    <div v-if="person._id" class='personPage'>
      <b-row class="mb-3" align-h="between">
        <b-col cols="auto">
          <p class="card-title mb-0 bold">{{ friendlyPersonId }}</p>
          <p class="small text-muted">Added {{ getPersonAddedDate() }}</p>
        </b-col>
        <b-col cols="auto">
          <router-link :to="'/person/' + friendlyPersonId + '/edit'" v-if="isAllowedToCreateOrEditPerson" class='marginR-16'>
            <b-button variant='secondary' >Edit</b-button>
          </router-link>
          <b-button class="mx-0" disabled v-else variant='secondary'>Edit</b-button>
          <router-link :to="'/person/' + friendlyPersonId + '/edit/supplement'" v-if="isAllowedToCreateOrEditPerson">
            <b-button type="button" variant="primary">Supplemental Information</b-button>
          </router-link>
          <b-button type="button" disabled variant="primary" v-else>Supplemental Information</b-button>
        </b-col>
      </b-row>
      <b-row style="height:20px">
        <b-col></b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div>
            <b-card no-body>
              <b-card-header>
                <b>Biographical Information</b>
                <label class="switch switch-text infoActiveToggle switch-primary pull-right mb-0 active-toggle">
                  <input id="positive_switch" :disabled="!isAllowedToCreateOrEditPerson" @change="toggleActive" type="checkbox" class="switch-input disabled" :checked="!person.inactive">
                  <span class="switch-label" data-on="Active" data-off="Inactive"></span>
                  <span class="switch-handle"></span>
                </label>
              </b-card-header>
              <b-card-body>
                <div v-show="showname">
                  <div class="pb-4">
                    <small class="mb-0 text-muted text-uppercase font-weight-bold">Name</small>
                    <br>
                    <h4>{{ person.b_first_name + ' ' + person.b_last_name }}</h4>
                  </div>
                  <div v-show="person.b_nickname || person.p_street_name" class="pb-4">
                    <small class="mb-0 text-muted text-uppercase font-weight-bold">NickName</small>
                    <br>
                    <h4>{{ person.b_nickname || person.p_street_name }}</h4>
                  </div>
                </div>
                <b-button
                  variant="outline-secondary"
                  class='marginB-24'
                  @click="togglename"
                  v-model="showname"
                >{{ showname ? 'Hide name' : 'Show name' }}</b-button>
                <div class="pb-4">
                  <p class="card-text mb-0">
                    <small class="mb-0 text-muted text-uppercase font-weight-bold">VICTIM INITIALS</small>
                    <br>
                  </p>
                  <h4 class=" mt-0 mb-0 text-uppercase">
                    {{ person.b_first_name[0] +  person.b_last_name[0]}}
                  </h4>
                </div>
                <div class="pb-4" v-for="(field, key) in getFields('biographical')" :key="key">
                  <p class="card-text mb-0">
                    <small class="mb-0 text-muted text-uppercase font-weight-bold">{{ field.label }}</small>
                    <br>
                  </p>
                  <h4 class=" mt-0 mb-0">
                    {{ displayFieldData(field) }}
                  </h4>
                </div>
              </b-card-body>
            </b-card>
            <b-card no-body>
              <b-card-header>
                <b>Victim Information</b>
                <label class="switch switch-sm switch-text infoActiveToggle switch-primary mb-0 pull-right">
                  <input id="positive_switch" @change="toggleVictimStatus" type="checkbox" class="switch-input" :checked="showVictimStatus">
                  <span class="switch-label" data-on="On" data-off="Off"></span>
                  <span class="switch-handle"></span>
                </label>
              </b-card-header>
               <b-collapse id="victiminfosection" v-model="showVictimStatus">
                <b-row>
                  <b-col v-if="victimInfo.length" v-for="(field, key) in getFormattedDataForTraffickingTypes()" :key="key" sm="6">
                    <b-card-body>
                      <p class="card-text mb-0">
                        <small
                          class="mb-0 text-muted text-uppercase font-weight-bold"
                        >{{ field.label }}</small>
                        <br>
                      </p>
                      <h4 class=" mt-0 mb-0">{{ maybeFormatDate(field) }}</h4>
                      <div v-for="(item, key) in field.value" :key="key">
                         <h4 class=" mt-0 mb-0">{{ item.startsWith('*') ? '' : item}}</h4>
                         <p style ="padding-left: 20px">{{ item.startsWith('*') ? item.split('*').pop() : ''}}</p>
                      </div>
                    </b-card-body>
                  </b-col>
                  <!-- <b-col v-for="(field) in getFields('victimStatus')" :key="field.label" sm="6">
                    <b-card-body>
                      <p class="card-text mb-0">
                        <small
                          class="mb-0 text-muted text-uppercase font-weight-bold"
                        >{{ field.label }}</small>
                        <br>
                      </p>
                      <b-list-group v-for="fieldValue in field.value" :key="fieldValue">
                          <h4 class=" mt-0 mb-0">{{fieldValue}}</h4>
                      </b-list-group>
                    </b-card-body>
                  </b-col> -->
                </b-row>
              </b-collapse>
            </b-card>

            <b-card no-body>
              <b-card-header>
                <b>Services</b>
                <label class="switch switch-sm switch-text infoActiveToggle switch-primary mb-0 pull-right">
                  <input id="positive_switch" @change="toggleServices" type="checkbox" class="switch-input" :checked="showServices">
                  <span class="switch-label" data-on="On" data-off="Off"></span>
                  <span class="switch-handle"></span>
                </label>
              </b-card-header>
               <b-collapse id="servicessection" v-model="showServices">
                <b-row>
                  <b-col v-for="(field, key) in getFields('services')" :key="key" sm="6">
                    <b-card-body>
                      <p class="card-text mb-0">
                        <small
                          class="mb-0 text-muted text-uppercase font-weight-bold"
                        >{{ field.label }}</small>
                        <br>
                      </p>
                      <div v-if="field.label === 'Services Provided During Program Enrollment'">
                        <div v-for="(item, key) in maybeFormatDate(field).split(',')" :key="key">
                          <h4 class=" mt-0 mb-0">{{item}}</h4>
                        </div>
                      </div>
                      <div v-else>
                        <h4 class=" mt-0 mb-0">{{ maybeFormatDate(field) }}</h4>
                      </div>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-collapse>
            </b-card>

            <b-card no-body>
              <b-card-header>
                <b>Supplemental Information</b>
                <label class="switch switch-sm switch-text infoActiveToggle switch-primary mb-0 pull-right">
                  <input id="positive_switch" @change="togglet1" type="checkbox" class="switch-input" :checked="showt1">
                  <span class="switch-label" data-on="On" data-off="Off"></span>
                  <span class="switch-handle"></span>
                </label>
              </b-card-header>
              <b-collapse id="tieronesection" v-model="showt1">
                <b-row>
                  <b-col v-for="(field, key) in getFields('t1p')" :key="key" sm="6">
                    <b-card-body>
                      <p class="card-text mb-0">
                        <small
                          class="mb-0 text-muted text-uppercase font-weight-bold"
                        >{{ field.label }}</small>
                        <br>
                      </p>
                      <h4 class=" mt-0 mb-0">{{ maybeFormatDate(field) }}</h4>
                    </b-card-body>
                  </b-col>
                  <!-- <b-col v-for="(field) in getFields('t1p_trafficking')" :key="field.label" sm="6">
                    <b-card-body>
                      <p class="card-text mb-0">
                        <small
                          class="mb-0 text-muted text-uppercase font-weight-bold"
                        >{{ field.label }}</small>
                        <br>
                      </p>
                      <b-list-group v-for="fieldValue in field.value" :key="fieldValue">
                          <h4 class=" mt-0 mb-0">{{fieldValue}}</h4>
                      </b-list-group>
                    </b-card-body>
                  </b-col> -->
                  <b-col sm="6" v-if="getFields('t1p_location').length > 0">
                    <b-card-body>
                      <p class="card-text mb-0">
                        <small
                          class="mb-0 text-muted text-uppercase font-weight-bold"
                        >Last Home Location</small>
                        <br>
                      </p>
                      <div v-for="(field, key) in getFields('t1p_location')" :key="key">
                        <h4 class=" mt-0 mb-0">{{ field.value ? field.value : maybeFormatDate(field)}}</h4>
                      </div>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-collapse>
            </b-card>
          </div>
        </b-col>
        <b-col sm="4">
          <b-row>
            <b-col sm="12">
              <b-card
                v-if="shouldShowVictimStatusCard"
                :bg-variant="colorByVictimStatus"
                style="border: none !important;"
              >
                <p class='bold'>Victim Status</p>
                <p class="marginB0">{{ victimStatus }}</p>
              </b-card>
            </b-col>
          </b-row>

          <!-- Person Share -->
          <b-row>
            <b-col sm="12">
              <SharePersonList :personId="person._id" :personOrganizationOwner="person.organizationOwner.id"></SharePersonList>
            </b-col>
          </b-row>
          <!-- CSE-IT LIST -->
          <b-row>
            <b-col sm="12">
              <ShareCseit :isAllowedToCreateOrEditPerson="isAllowedToCreateOrEditPerson" :cseits="cseits" :friendlyPersonId="this.friendlyPersonId"></ShareCseit>
            </b-col>
          </b-row>
          <!-- Labor Screening List -->
          <b-row v-if="isUserInLA">
            <b-col sm="12">
              <ShareLaborScreening 
              :isAllowedToCreateOrEditPerson="isAllowedToCreateOrEditPerson" 
              :laborScreenings="laborScreenings" 
              :personId="this.friendlyPersonId" />
            </b-col>
          </b-row>
          <!-- New LA Sex Trafficking Screening List -->
          <b-row v-if="isUserInLA">
            <b-col sm="12">
              <TraffickingScreeningCard 
              :isAllowedToCreateOrEditPerson="isAllowedToCreateOrEditPerson" 
              :oldScreenings="oldTraffickingScreenings" 
              :screenings="traffickingScreenings" 
              :person="person"
              :personId="this.friendlyPersonId" 
              />
            </b-col>
          </b-row>
          <!-- LA Sex Trafficking Screening List -->
          <!-- <b-row v-if="isUserInLA">
            <b-col sm="12">
              <TraffickingScreeningList
                :isAllowedToCreateOrEditPerson="isAllowedToCreateOrEditPerson"
                :traffickingScreenings="traffickingScreenings"
                :person="person"
              />
            </b-col>
          </b-row> -->
          <!-- Assessment List -->
          <b-row>
            <b-col sm="12">
              <b-card no-body>
                <b-card-header>
                  <b>Lighthouse Indicators</b>

                  <router-link v-if="isAllowedToCreateOrEditPerson" :to="'/screening/' + friendlyPersonId + '/add'">
                    <b-button variant="outline-primary" class="headerBtn">Add Indicators</b-button>
                  </router-link>
                  <b-button v-else disabled variant="outline-primary" class="headerBtn">Add Indicators</b-button>
                </b-card-header>
                <div v-if="_.isArray(assessments) && assessments.length > 0">
                  <b-list-group v-for="a in assessments" :key="a.id" flush>
                    <router-link :class="'concl_' + a.dmst_conclusion" :to="'/screening/' + a.id">
                      <b-list-group-item>
                        {{ $moment(a.createdAt).format('MM/DD/YYYY') }}
                        {{ a.id }}
                        <img
                          v-if="a.dmst_conclusion == 'Yes'"
                          class="icon-danger"
                          :src="'/static/img/ConcernDanger.png'"
                          height="21"
                          width="21"
                        >
                        <img
                          v-if="assessmentIsShared(a)"
                          :src="'/static/img/shareYes.png'"
                          height="21"
                          width="21"
                        >
                      </b-list-group-item>
                    </router-link>
                  </b-list-group>
                </div>

                <b-list-group v-if="!_.isArray(assessments) || assessments.length === 0" flush>
                  <b-list-group-item>
                    <p>No Lighthouse Indicators found</p>
                    <p>{{ _.get(personAssessmentsResponse, 'body.message', '') }}</p>
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12">
              <b-card no-body>
                <b-card-header>
                  <b>Case Notes</b>
                  <b-button
                    :disabled="!isAllowedToCreateOrEditPerson"
                    @click="addNoteModal"
                    variant="outline-primary"
                    class="headerBtn"
                  >Add Case Note</b-button>
                </b-card-header>
                <b-list-group v-for="note in notes" :key="note.id" flush>
                  <!-- TO DO - link leading to modal that has date/title/comment -->
                  <b-list-group-item @click="viewNoteModal(note)">
                    <a href @click.prevent class="concl_">
                      {{ $moment(note.customDate).format('MM/DD/YYYY') }}
                      {{ note.title }}
                      <img
                        v-if="noteIsShared(note)"
                        :src="'/static/img/shareYes.png'"
                        height="21"
                        width="21"
                      >
                    </a>
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
          </b-row>

          <b-row class="pt-3" v-if="person.case_notes !== '' && person.case_notes !== null">
            <b-col sm="12">
              <b-card no-body>
                <b-card-header>
                  <b>Case Notes</b>
                  <b-button
                    @click="addNoteModal"
                    variant="outline-primary"
                    class="headerBtn"
                  >Add Case Note</b-button>
                </b-card-header>
                <b-list-group>
                  <b-list-group-item></b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
          </b-row>

          <AddNoteModal
            v-if="addNoteActive"
            :personId="this.personId"
            @modalClose="closeAddNoteModal"
          ></AddNoteModal>

          <ViewNoteModal
            v-if="viewNoteActive"
            :isAllowedToCreateOrEditPerson="isAllowedToCreateOrEditPerson"
            :note="viewNote"
            @modalClose="closeViewNoteModal">
          </ViewNoteModal>

          <!-- Advocates -->
          <b-row>
            <b-col sm="12">
              <b-card no-body>
                <b-card-header>
                  <b>Advocates</b>
                  <b-button
                    :disabled="!isAllowedToCreateOrEditPerson"
                    @click="addAdvocateModal"
                    variant="outline-primary"
                    class="headerBtn">Add Advocate</b-button>
                </b-card-header>
                <b-list-group v-for="advocate in getAdvocatesInOrder(advocates)" :key="advocate.id" flush>
                  <b-list-group-item @click="viewAdvocateModal(advocate)">
                    <a href @click.prevent class="concl_">
                      {{ advocate.name }}
                      <img
                        height="21"
                        width="21"
                        :src="'static/img/' + (!advocate.active ? 'Inactive.png' : 'ManagerYes.png')"
                      >
                      <img
                        v-if="advocateIsShared(advocate)"
                        :src="'/static/img/shareYes.png'"
                        height="21"
                        width="21"
                      >
                    </a>
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
          </b-row>
          <AddAdvocateModal
            v-if="addAdvocateActive"
            :person="person"
            :personId="this.personId"
            @modalClose="closeAddAdvocateModal">
          </AddAdvocateModal>

          <ViewAdvocateModal
            v-if="viewAdvocateActive"
            :isAllowedToCreateOrEditPerson="isAllowedToCreateOrEditPerson"
            :viewAdvocate="this.viewAdvocate"
            :person="person"
            @modalClose="closeViewAdvocateModal"
            :personId="this.personId">
          </ViewAdvocateModal>

          <!-- External Ids -->
          <b-row>
            <b-col sm="12">
              <PersonExternalIds :isAllowedToCreateOrEditPerson="isAllowedToCreateOrEditPerson" :personId="person._id"></PersonExternalIds>
            </b-col>
          </b-row>

          <!-- Meta -->
          <b-row>
            <b-col sm="12">
              <b-card no-body>
                <b-card-header>
                  <b>Meta</b>
                </b-card-header>

                <b-list-group flush>
                  <b-list-group-item class="small text-muted">
                    <b>Created At: </b> {{ getCreatedAt() }}
                    <div v-if="_.isObject(person.createdBy)">
                      <b> by: </b> {{ _.get(person, 'createdBy.emailAddress', '') }}
                    </div>
                  </b-list-group-item>

                  <b-list-group-item class="small text-muted">
                    <b>Last Updated: </b> {{ getLastUpdateDate() }}
                    <div v-if="_.isObject(person.updatedBy)">
                      <b> by: </b> {{ _.get(person, 'updatedBy.emailAddress', '') }}
                    </div>
                  </b-list-group-item>
                  <b-list-group-item class="small text-muted">
                    <b>Current Record Owner: </b> {{ _.get(person, 'organizationOwner.title') }}
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AddNoteModal from '@/views/t1/AddNoteModal'
import AddAdvocateModal from '@/views/t1/AddAdvocateModal'
import ViewAdvocateModal from '@/views/t1/ViewAdvocateModal'
import ViewNoteModal from '@/views/t1/ViewNoteModal'
import SharePersonList from '@/components/Person/SharePersonList'
import PersonExternalIds from '@/components/Person/PersonExternalIds'
import ShareCseit from '@/components/Cseit/ShareCseit'
import ShareLaborScreening from '@/components/LaborScreening/ShareLaborScreening'
import TraffickingScreeningCard from '@/components/TraffickingScreening/TraffickingScreeningCard'
// import TraffickingScreeningList from '@/components/TraffickingScreening/TraffickingScreeningList'
import userStateMixin from '@/mixins/userState.js'
import userPermissionMixin from '@/mixins/userPermission.js'

export default {
  name: 'person',
  mixins: [userStateMixin, userPermissionMixin],
  components: {
    AddNoteModal,
    AddAdvocateModal,
    ViewNoteModal,
    ViewAdvocateModal,
    ShareCseit,
    ShareLaborScreening,
    // TraffickingScreeningList,
    TraffickingScreeningCard,
    SharePersonList,
    PersonExternalIds
  },
  // mounted () {
  //   if (this.$auth.user()) {
  //     this.$store.commit('updateAuthUserInfo', {
  //       isCseitTrained: this.$auth.user().isCseitTrained,
  //       userInLA: this.$auth.user().primaryOrganization.mailingStateAbbreviation === 'LA',
  //       userInTX: this.$auth.user().primaryOrganization.mailingStateAbbreviation === 'TX'
  //     })
  //   }
  // },
  computed: {
    ...mapGetters({
      // authUserInfo: 'authUserInfo',
      person: 'getViewPerson',
      assessments: 'getAssessmentsByPerson',
      cseits: 'getCseitsByPerson',
      laborScreenings: 'getLaborScreeningsByPerson',
      oldTraffickingScreenings: 'getOldTraffickingScreenings',
      traffickingScreenings: 'getTraffickingScreeningsByPerson',
      fields: 'getPersonFields',
      notes: 'getPersonNotes',
      advocates: 'getPersonAdvocates',
      countries: 'getCountries', // ISO-3166-1-Alpha-3Codes data
      userCurrentContext: 'userCurrentContext',
      personAssessmentsResponse: 'getPersonAssessmentsResponse',
      viewNote: 'getViewNote',
      viewAdvocate: 'getViewAdvocate',
      updateAdvocate: 'getUpdateAdvocate',
      sharePersonRecords: 'sharePersonRecords',
      victimInfo: 'getPersonVictimInfo'
    }),

    victimStatus () {
      return this.person.b_confirmed === 'Yes' ? 'Confirmed' : this.person.b_confirmed
    },

    shouldShowVictimStatusCard () {
      const victimStatusToShow = [
        'Yes',
        'Pending',
        'Suspected',
        'At-Risk',
        'Unknown',
        'No',
        'Other'
      ]

      return victimStatusToShow.includes(this.person.b_confirmed)
    },

    colorByVictimStatus () {
      switch (this.person.b_confirmed) {
        case 'Yes':
          return 'danger'
        case 'Suspected':
          return 'warning'
        case 'Pending':
        case 'At-Risk':
          return 'primary'
        case 'Unknown':
        case 'Other':
          return 'secondary'
      }

      return 'default'
    }
  },
  methods: {
    getAdvocatesInOrder (advocates) {
      const sortedAdvocatesList = JSON.parse(JSON.stringify(advocates))
      sortedAdvocatesList.sort((a, b) => {
        // sort by active status first
        if (a.active < b.active) {
          return 1
        } else if (a.active > b.active) {
          return -1
        }
        // sort by createdAt
        return a.createdAt < b.createdAt ? 1 : -1
      })
      return sortedAdvocatesList
    },
    assessmentIsShared: function () {
      return this.sharePersonRecords.length
      // const records = a.sharingRecords
      // const hasRecords = !_.isEmpty(records)
      // if (!hasRecords) {
      //   return false
      // }

      // const active = records.filter((a) => a.assessmentShareStatus)
      // return active.length > 0
    },
    noteIsShared: function () {
      return this.sharePersonRecords.length
      // const records = note.sharingRecords
      // const hasRecords = !_.isEmpty(records)
      // if (!hasRecords) {
      //   return false
      // }

      // const active = records.filter((a) => a.noteShareStatus)
      // return active.length > 0
    },
    advocateIsShared: function () {
      return this.sharePersonRecords.length
      // const records = a.sharingRecords
      // const hasRecords = !_.isEmpty(records)
      // if (!hasRecords) {
      //   return false
      // }

      // const active = records.filter((a) => a.advocateShareStatus)
      // return active.length > 0
    },
    toggleActive: function () {
      const orgId = _.get(this.userCurrentContext, 'organization.id', false)
      const groupId = _.get(this.userCurrentContext, 'group.id', false)
      this.person.inactive = !this.person.inactive
      this.$store.dispatch('updatePersonToggle', {
        ...this.person,
        orgId,
        groupId
      })
    },
    togglet1: function () {
      this.showt1 = !this.showt1
    },
    toggleVictimStatus: function () {
      this.showVictimStatus = !this.showVictimStatus
    },
    toggleServices: function () {
      if (this.person.inactive) {
        this.showServices = false
      } else {
        this.showServices = !this.showServices
      }
    },
    togglename: function () {
      this.showname = !this.showname
    },
    excludes: function () {
      return [
        '_id',
        'createdAt',
        'updatedAt',
        'timestamp',
        'b_confirmed',
        'b_first_name',
        'b_last_name',
        'p_tattoo_photo'
      ]
    },
    getFields: function (categoryName) {
      let fields = this.fields
      let exclusions = this.excludes()
      let _ = this._
      let person = this.person
      let knownBirthDate = this.person['b_birthdate'] !== '0000-00-00 00:00:00' && this.person['b_birthdate'] !== '' && this.person['b_birthdate']

      if (categoryName === 'biographical') {
        let birthdateIdx = -1
        const birthdate = fields
          .filter(({name}, id) => {
            if (name === 'b_birthdate') {
              birthdateIdx = id
            }
            return name === 'b_birthdate'
          })[0]
        if (birthdate && birthdateIdx > -1 && this.person[birthdate.name]) {
          if (!this.person['age']) {
            this.person['age'] = this.calculatePersonAge(this.person[birthdate.name])
          }
          const age = fields.filter(({name}) => name === 'age')[0]
          if (!age) {
            const ageField = {
              name: 'age',
              label: 'Age',
              category: 'biographical',
              yesNo: false
            }
            fields.splice(birthdateIdx + 1, 0, ageField)
          }
        }
      }

      const parentFields = ['p_perpetrator_known', 'p_cps_called', 'p_cac_interview', 'p_le_called', 'p_gang_affiliation', 'p_tattoos', 'p_runaway', 'p_substance_use', 'p_social_media', 'p_csey_advocate_called']
      const parentFieldsMap = {}
      for (let i = 0; i < parentFields.length; i++) {
        const fieldName = parentFields[i]
        const fieldMask = fieldName.split('_').slice(0, 2).join('_')
        parentFieldsMap[fieldMask] = person[fieldName] === 'Yes'
      }

      fields = _.filter(this.fields, function (field) {
        let fieldValue = person[field.name]

        let fieldGroup = field.name.split('_').slice(0, 2).join('_')
        switch (fieldGroup) {
          case 'p_tattoo':
            fieldGroup = 'p_tattoos'
            break
          case 'p_outcry':
            fieldGroup = 'p_cac'
            break
          default:
            break
        }

        if (parentFieldsMap[fieldGroup] === false) {
          return false
        }

        if (field.name === 'b_approximate_age' && knownBirthDate) {
          return false
        }
        // Remove falsey values - things like '', null, etc.
        if (!_.identity(fieldValue)) {
          return false
        }

        if (fieldValue === 'Not Observed') {
          return false
        }

        // Remove empty dates
        if (fieldValue === '0000-00-00 00:00:00') {
          return false
        }

        // Check our exclusions list
        if (_.includes(exclusions, field.name)) {
          return false
        }

        // Check our category
        if (field.category !== categoryName) {
          return false
        }

        // Anything else is a big thumbs up
        return true
      })

      // Map any values from static lists where the value is different from the label text
      // Ex - Country of Origin
      const countryIndex = _.findIndex(
        fields,
        f => f.name === 'p_country_of_origin'
      )

      if (countryIndex >= 0) {
        const country = this.person['p_country_of_origin']
        const countryLookup = _.find(this.countries, c => c.value === country)
        if (countryLookup) {
          this.person['p_country_of_origin'] = countryLookup.text
        }
      }

      const countryLocationIndex = _.findIndex(
        fields,
        f => f.name === 'b_location_of_trafficking_out_country'
      )

      if (countryLocationIndex >= 0) {
        const countryLocation = this.person['b_location_of_trafficking_out_country']
        const countryLocationLookup = _.find(this.countries, c => c.value === countryLocation)
        if (countryLocationLookup) {
          this.person['b_location_of_trafficking_out_country'] = countryLocationLookup.text
        }
      }

      const countryOriginIndex = _.findIndex(
        fields,
        f => f.name === 'b_location_of_origin_country'
      )

      if (countryOriginIndex >= 0) {
        const countryOrigin = this.person['b_location_of_origin_country']
        const countryOriginLookup = _.find(this.countries, c => c.value === countryOrigin)
        if (countryOriginLookup) {
          this.person['b_location_of_origin_country'] = countryOriginLookup.text
        }
      }

      if (categoryName === 't1p_location') {
        return this.getFormattedDataForLocation(fields)
      }

      return fields
    },
    calculatePersonAge (date) {
      const today = new Date()
      const currentYear = today.getUTCFullYear()
      const currentMonth = today.getUTCMonth() + 1
      const currentDay = today.getUTCDate()

      const birthdate = new Date(date)
      const birthYear = birthdate.getUTCFullYear()
      const birthMonth = birthdate.getUTCMonth() + 1
      const birthDay = birthdate.getUTCDate()

      let age = currentYear - birthYear
      if (birthMonth < currentMonth) {
        return age
      } else if (birthMonth === currentMonth) {
        if (birthDay <= currentDay) {
          return age
        } else {
          return age - 1
        }
      }
      return age - 1
    },
    getFormattedDataForLocation (fields) {
      let fieldData = []
      const prefix = 'p_last_home_location_'
      const fieldsToGroup = ['city', 'state', 'zip']
      fieldData = fields.filter((field) =>
        field.name && !fieldsToGroup.includes(field.name.substring(21))
      )
      if (fieldData.length === 0) {
        return fields
      }
      const city = this.person[`${prefix}city`] ? this.person[`${prefix}city`] : ''
      const state = this.person[`${prefix}state`] ? this.person[`${prefix}state`] : ''
      const zip = this.person[`${prefix}zip`] ? this.person[`${prefix}zip`] : ''
      let groupedValue = `${city}`
      if (city && (state || zip)) {
        groupedValue += ','
      }
      groupedValue = `${groupedValue} ${state} ${zip}`
      return [
        ...fieldData,
        {
          value: groupedValue
        }
      ]
    },
    getFormattedDataForTraffickingTypes () {
      let fieldData = []
      const victimStatusFields = this.fields.filter((field) => field.category === 'victimStatus')
      const locationFields = victimStatusFields.filter((field) => field.name.startsWith('b_location'))
      const confirmFields = victimStatusFields.filter((field) => [
        'b_confirmation_LE',
        'b_confirmation_CPS',
        'b_confirmation_Victim',
        'b_confirmation_Med',
        'b_confirmation_Expert',
        'b_confirmation_Other',
        'b_confirmation_LE_date'
      ].includes(field.name))
      const traffickingTypeValueToLabel = {
        sex: 'Sex Trafficking & Exploitation',
        labor: 'Labor Trafficking & Exploitation',
        forced_marriage: 'Forced Marriage'
      }

      fieldData.push({
        label: 'Type of Trafficking',
        value: this.victimInfo
          .map((victim) => traffickingTypeValueToLabel[victim.b_type_of_trafficking])
          .filter((info) => !!info)
      })

      for (const victim of this.victimInfo) {
        const traffickingType = victim['b_type_of_trafficking']

        // Means of trafficking
        let meansOfTrafficking = []
        let label = ''
        switch (traffickingType) {
          case 'sex': {
            label = 'Means of Sex Trafficking'
            meansOfTrafficking = victimStatusFields
              .filter((field) => field.name.startsWith('i_s') && victim[field.name])
              .map((field) => field.label)
            break
          }
          case 'labor': {
            label = 'Means of Labor Trafficking'
            meansOfTrafficking = victimStatusFields
              .filter((field) => field.name.startsWith('i_l') &&
                field.name !== 'i_l_industry_related' &&
                victim[field.name]
              )
              .map((field) => {
                if (field.name.startsWith('i_l_trafficked_industry')) {
                  return `Industry Related: ${victim[field.name]}`
                }

                return field.label
              })
              break
          }
          default:
            break
        }

        fieldData.push({
          label,
          value: meansOfTrafficking
        })

        // Locations
        fieldData = fieldData.concat(
          locationFields.map((field) => ({
            label: `${field.label} - ${traffickingTypeValueToLabel[victim.b_type_of_trafficking]}`,
            value: [victim[field.name]]
          })).filter((field) => !!field.value[0])
        )

        // Victim status
        confirmFields.map((field) => {
          if (victim[field.name] && victim[field.name] !== '0000-00-00 00:00:00') {
            this.updateFieldValueWithLabelVictimInformation(
              `Victim Confirmation - ${traffickingTypeValueToLabel[victim.b_type_of_trafficking]}`,
              fieldData,
              field.label,
              field.name,
              victim[field.name]
            )
          }
        })
      }

      return fieldData.filter((field) => field.value && field.value.length >= 0 ? !!field.value.length : !!field.value)
    },
    updateFieldValueWithLabelVictimInformation (fieldLabel, fieldData, fieldValue, kf, victimInfo) {
      const fieldToUpdateIndex = fieldData.findIndex(({ label }) =>
        label === fieldLabel)
      let fieldToUpdate = fieldData[fieldToUpdateIndex] ||
        {'label': fieldLabel,
          'value': []}
      if (kf === 'b_confirmation_LE') {
        fieldToUpdate['value'].push(fieldValue)
         let string = '*'
        if (victimInfo['b_confirmation_LE_date']) {
          let date = victimInfo['b_confirmation_LE_date'].split('T').shift().split('-')
          let day = date[2]
          let month = date[1]
          let year = date[0]
          let formattedDate = month + '/' + day + '/' + year
           string += formattedDate
        }
        if (victimInfo['b_confirmation_LE_comment']) {
          if (string.length > 1) {
            string += ', ' + victimInfo['b_confirmation_LE_comment']
          } else {
            string += victimInfo['b_confirmation_LE_comment']
          }
        }
        fieldToUpdate['value'].push(string)
      }
      if (kf === 'b_confirmation_Victim') {
        fieldToUpdate['value'].push(fieldValue)
        let string = '*'
        if (victimInfo['b_confirmation_Victim_date']) {
          let date = victimInfo['b_confirmation_Victim_date'].split('T').shift().split('-')
          let day = date[2]
          let month = date[1]
          let year = date[0]
          let formattedDate = month + '/' + day + '/' + year
          string += formattedDate
        }
        if (victimInfo['b_confirmation_Victim_comment']) {
          if (string.length > 1) {
            string += ', ' + victimInfo['b_confirmation_Victim_comment']
          } else {
            string += victimInfo['b_confirmation_Victim_comment']
          }
        }
        fieldToUpdate['value'].push(string)
      }
      if (kf === 'b_confirmation_CPS') {
        fieldToUpdate['value'].push(fieldValue)
        let string = '*'
        if (victimInfo['b_confirmation_CPS_date']) {
          let date = victimInfo['b_confirmation_CPS_date'].split('T').shift().split('-')
          let day = date[2]
          let month = date[1]
          let year = date[0]
          let formattedDate = month + '/' + day + '/' + year
          string += formattedDate
        }
        if (victimInfo['b_confirmation_CPS_comment']) {
          if (string.length > 1) {
            string += ', ' + victimInfo['b_confirmation_CPS_comment']
          } else {
            string += victimInfo['b_confirmation_CPS_comment']
          }
        }
        fieldToUpdate['value'].push(string)
      }
      if (kf === 'b_confirmation_Med') {
        fieldToUpdate['value'].push(fieldValue)
        let string = '*'
        if (victimInfo['b_confirmation_Med_date']) {
          let date = victimInfo['b_confirmation_Med_date'].split('T').shift().split('-')
          let day = date[2]
          let month = date[1]
          let year = date[0]
          let formattedDate = month + '/' + day + '/' + year
          string += formattedDate
        }
        if (victimInfo['b_confirmation_Med_comment']) {
          if (string.length > 1) {
            string += ', ' + victimInfo['b_confirmation_Med_comment']
          } else {
            string += victimInfo['b_confirmation_Med_comment']
          }
        }
        fieldToUpdate['value'].push(string)
      }
      if (kf === 'b_confirmation_Expert') {
        fieldToUpdate['value'].push(fieldValue)
        let string = '*'
        if (victimInfo['b_confirmation_Expert_date']) {
          let date = victimInfo['b_confirmation_Expert_date'].split('T').shift().split('-')
          let day = date[2]
          let month = date[1]
          let year = date[0]
          let formattedDate = month + '/' + day + '/' + year
          string += formattedDate
        }
        if (victimInfo['b_confirmation_Expert_comment']) {
           if (string.length > 1) {
            string += ', ' + victimInfo['b_confirmation_Expert_comment']
          } else {
            string += victimInfo['b_confirmation_Expert_comment']
          }
        }
        fieldToUpdate['value'].push(string)
      }
      if (kf === 'b_confirmation_Other') {
        fieldToUpdate['value'].push(fieldValue)
        let string = '*'
        if (victimInfo['b_confirmation_Other_date']) {
          let date = victimInfo['b_confirmation_Expert_date'].split('T').shift().split('-')
          let day = date[2]
          let month = date[1]
          let year = date[0]
          let formattedDate = month + '/' + day + '/' + year
          string += formattedDate
        }
        if (victimInfo['b_confirmation_Other_comment']) {
          if (string.length > 1) {
            string += ', ' + victimInfo['b_confirmation_Other_comment']
          } else {
            string += victimInfo['b_confirmation_Other_comment']
          }
        }
        fieldToUpdate['value'].push(string)
      }
      if (fieldToUpdateIndex <= -1) {
        fieldData.push(fieldToUpdate)
      } else {
        fieldData[fieldToUpdateIndex] = fieldToUpdate
      }
    },
    updateFieldValueWithLabel (fieldLabel, fieldData, fieldValue) {
      const fieldToUpdateIndex = fieldData.findIndex(({ label }) =>
        label === fieldLabel)
      let fieldToUpdate = fieldData[fieldToUpdateIndex] ||
        {'label': fieldLabel,
          'value': []}
      fieldToUpdate['value'].push(fieldValue)
      if (fieldToUpdateIndex <= -1) {
        fieldData.push(fieldToUpdate)
      } else {
        fieldData[fieldToUpdateIndex] = fieldToUpdate
      }
    },
    getPersonAddedDate: function () {
      const person = this.person

      if (person.timestamp) {
        return this.$utils.formatDate(person.timestamp)
      }

      if (person.createdAt) {
        return this.$utils.unixToHuman(person.createdAt / 1000)
      }
    },
    getCreatedAt () {
      const person = this.person
      if (person.createdAt && person.createdAt.includes('T')) {
        return this.$utils.formatDate(person.createdAt)
      } else if (person.createdAt) {
        return this.$utils.unixToHuman(person.createdAt / 1000)
      }
    },
    getLastUpdateDate: function () {
      const person = this.person
      if (person.updatedAt && person.updatedAt.includes('T')) {
        return this.$utils.formatDate(person.updatedAt)
      } else if (person.updatedAt) {
        return this.$utils.unixToHuman(person.updatedAt / 1000)
      }
    },
    displayFieldData: function (field) {
      if (field.label === 'Race' && this.person.b_race === 'Other') {
        return this.maybeFormatDate(field) + '-' + this.person.b_race_otherText
      } else if (field.label === 'Ethnicity' && this.person.b_ethnicity === 'Other') {
        return this.maybeFormatDate(field) + '-' + this.person.b_ethnicity_otherText
      } else if (field.label === 'Gender Assigned at Birth' && this.person.b_gender === 'Other') {
        return this.maybeFormatDate(field) + '-' + this.person.b_gender_otherText
      } else if (field.label === 'Current Gender Identity' && this.person.b_gender_identity === 'Other') {
        return this.maybeFormatDate(field) + '-' + this.person.b_gender_identity_otherText
      } else if (field.label === 'Orientation' && this.person.b_orientation === 'Other') {
        return this.maybeFormatDate(field) + '-' + this.person.b_orientation_otherText
      } else {
        return this.maybeFormatDate(field)
      }
    },
    maybeFormatDate: function (field) {
      let value = this.person[field.name]
      let name = field.name

      if (value) {
        if (
          name.indexOf('_date') >= 0 ||
          name === 'timestamp' ||
          name === 'b_birthdate'
        ) {
          if (value !== '0000-00-00 00:00:00') {
            return this.$moment(value).format('MM/DD/YYYY')
          } else {
            return ''
          }
        }
      }
      return value
    },
    organizationMailingAddress: function () {
      return (
        this.person.organization.mailingStreet +
        ' ' +
        this.person.organization.mailingCity +
        ', ' +
        this.person.organization.mailingStateAbbreviation +
        ' ' +
        this.person.organization.mailingPostalCode
      )
    },
    addNoteModal: function () {
      this.addNoteActive = true
    },
    closeAddNoteModal: function () {
      this.addNoteActive = false
    },
    viewNoteModal: function (note) {
      this.viewNoteActive = true
      this.$store.commit('SET_VIEW_NOTE', _.clone(note))
    },
    closeViewNoteModal: function () {
      this.viewNoteActive = false
      this.$store.commit('RESET_VIEW_NOTE')
    },
    addAdvocateModal: function () {
      this.addAdvocateActive = true
    },
    closeAddAdvocateModal: function () {
      this.addAdvocateActive = false
    },
    viewAdvocateModal: function (advocate) {
      this.viewAdvocateActive = true
      this.$store.commit('SET_VIEW_ADVOCATE', advocate)
    },
    closeViewAdvocateModal: function () {
      this.viewAdvocateActive = false
      this.$store.commit('RESET_VIEW_ADVOCATE')
    },
    populateRecords: function () {
      const friendlyPersonId = this.$route.params.id

      this.$store.dispatch('getPerson', {
        id: friendlyPersonId
      })

      this.$store.dispatch('getAssessmentsByPerson', { person_id: friendlyPersonId })
    }
  },
  data: function () {
    return {
      friendlyPersonId: '',
      personId: 0,
      timestamp: '',
      b_confirmed: '',
      dmst_conclusion: '',
      showt1: false,
      showVictimStatus: false,
      showServices: false,
      showname: false,
      addNoteActive: false,
      addAdvocateActive: false,
      viewNoteActive: false,
      viewAdvocateActive: false
    }
  },
  watch: {
    person: function (newValue, oldValue) {
      if (newValue._id) {
        this.$store.dispatch('addViewPersonLog', {
          id: newValue._id
        })

        this.$store.dispatch('getPersonVictimInfo', {
          person: newValue._id
        })

        // Note: watch out for the id vs _id
        // id comes from the original dataset
        // _id is our actually primary key
        this.$store.dispatch('getPersonNotes', {
          person: newValue._id,
          populate: 'createdBy,updatedBy,organizationOwner'
        })

        this.$store.dispatch('getPersonAdvocates', {
          person: newValue._id,
          populate: 'createdBy,updatedBy,organizationOwner,organization'
        })

        this.$store.dispatch('getCseitsByPerson', { person: newValue._id })
        if (this.isUserInLA) { // this.authUserInfo.userInLA
          this.$store.dispatch('getLaborScreeningsByPerson', { person: newValue._id })
          this.$store.dispatch('getOldTraffickingScreenings', { person: newValue._id })
          this.$store.dispatch('getTraffickingScreeningsByPerson', { person: newValue._id })
        }

        this.friendlyPersonId = newValue.id
        this.personId = newValue._id
        if (this.person.inactive) {
          this.showVictimStatus = false
        } else if (newValue.b_confirmed) {
          this.showVictimStatus = true
        }
        if (this.person.inactive) {
          this.showServices = false
        } else if (newValue.s_program_entry_date || newValue.s_program_discharge_date || newValue.s_discharge_reason || newValue.s_selected_services) {
          this.showServices = true
        }
        if (this.person.inactive) {
          this.showt1 = false
        } else if (newValue.p_presenting_offense || newValue.p_runaway === 'Yes' || newValue.p_pid || newValue.p_substance_use === 'Yes' || newValue.p_social_media === 'Yes' || newValue.p_le_called === 'Yes' || newValue.p_perpetrator_known === 'Yes' || newValue.p_cps_called === 'Yes' || newValue.p_cac_interview === 'Yes' || newValue.p_csey_advocate_called === 'Yes' || newValue.p_gang_affiliation === 'Yes' || newValue.p_tattoos === 'Yes' || newValue.p_substance_use_description === 'Yes' || newValue.p_last_home_location || newValue.p_last_home_location_city || newValue.p_last_home_location_street || newValue.p_last_home_location_state || newValue.p_last_home_location_zip) {
           this.showt1 = true
        }
      }
    },
    userCurrentContext: function (newValue) {
      if (newValue) {
        this.populateRecords()
      }
    },
    updateAdvocate (newValue) {
      this.populateRecords()
    }
  },
  beforeDestroy: function () {
    this.$store.commit('resetPersonAssessments')
    this.$store.commit('resetViewPerson')
  },
  created: function () {
    this.populateRecords()
  }
}
</script>

<style lang="scss" scoped>

@media screen and (min-width: 1100px) {
  .card-header .btn-sm .plus {
    display: none;
  }
}

@media screen and (max-width: 1100px) {

  .card-header .btn-sm .button-text {
    display: none;
  }

  .card-header .btn-sm .plus {
    display: inline;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/t1/Person.vue